const RedBox = ({divStyle}) => {
  return (
    <div style={divStyle}>
      Hurray! 😇🥳
      <br />
      (This is my component RedBox)
    </div>
  )
}

export default RedBox
